import { render } from "./VideoSettingsModal.vue?vue&type=template&id=1d537716&scoped=true"
import script from "./VideoSettingsModal.vue?vue&type=script&lang=js"
export * from "./VideoSettingsModal.vue?vue&type=script&lang=js"

import "./VideoSettingsModal.vue?vue&type=style&index=0&id=1d537716&scoped=true&lang=less"
import "./VideoSettingsModal.vue?vue&type=style&index=1&id=1d537716&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d537716"]])

export default __exports__